var metaService = require("../services/metaService");

module.exports = {
    metaType:{
        QNAME_USERTASK:"tencent.sys.usertask.UserTask",
        QNAME_USERTASK_EQFAPPROVALFLOW:"tencent.sys.usertask.entitlement.EQFlowApprovalUserTask",//审批任务
        QNAME_USERTASK_EQFLOWFORMPRE:"tencent.sys.usertask.entitlement.EQFlowFormPreFillTask",//用户补充数据任务
        QNAME_USERTASK_REGFAPPROVALFLOW:"tencent.sys.usertask.register.RegisterApprovalUserTask",//注册审批任务
        QNAME_USERTASK_REGFLOWFORMPRE:"tencent.sys.usertask.register.RegisterFromFillTask",//用户补充数据任务
        QNAME_ENTITLEMENT_REQUEST:"tencent.sys.entitlement.EntitlementRequest",//权限申请
        QNAME_ATTRIBUTE_ADDON_SETTER: "tencent.sys.attribute.AttributeSetter",
        QNAME_ATTRIBUTE_ADDON_VALIDATOR:"tencent.sys.attribute.AttributeValidator",
        QNAME_ATTRIBUTE_DEFAULT_VALUE: "tencent.sys.attribute.AttributeDefaultValue",
        QNAME_LOGIN_ENTRANCE:"tencent.sys.access.login.entrance.LoginEntrance",
        QNAME_AD_LOGIN_ENTRANCE:"tencent.sys.access.login.entrance.ADLoginEntrance",
        QNAME_LDAP_LOGIN_ENTRANCE:"tencent.sys.access.login.entrance.LDAPLoginEntrance",
        QNAME_PWD_LOGIN_ENTRANCE:"tencent.sys.access.login.entrance.PWDLoginEntrance",
        QNAME_USER_TICKET_LOGIN:"tencent.sys.access.login.entrance.UserTicketLoginEntrance",
        QNAME_QR_LOGIN_ENTRANCE:"tencent.sys.access.login.entrance.QRLoginEntrance",
        QNAME_PRIORITY_LOGIN_ENTRANCE:"tencent.sys.access.login.entrance.PriorityLoginEntrance",
        QNAME_SMS_LOGIN_ENTRANCE:"tencent.sys.access.login.entrance.SMSLoginEntrance",
        QNAME_IAM_AUTH_REGISTER:"iam.action.auth.register.RegisterForm",

        QNAME_DICTIONARY_DATA:"tencent.sys.dictionary.DictionaryData",
        QNAME_ACTION:"tencent.sys.action.Action",
        QNAME_ACTION_FORM:"tencent.sys.action.FormAction",
        QNAME_NOTIFY_SMSVERIFYCONFIG:"tencent.sys.notify.SmsVerifyConfig",

        ATTR_SETTER_TYPE_LINK_TO:"ATTR_SETTER_TYPE_LINK_TO",
        ATTR_SETTER_TYPE_GLOBAL_DICTIONARY:"ATTR_SETTER_TYPE_GLOBAL_DICTIONARY",
        ATTR_SETTER_TYPE_INTERNAL_DICTIONARY:"ATTR_SETTER_TYPE_INTERNAL_DICTIONARY",
        ATTR_SETTER_TYPE_UPLOAD_FILES:"ATTR_SETTER_TYPE_UPLOAD_FILES",
        ATTR_SETTER_TYPE_UPLOAD_IMAGE:"ATTR_SETTER_TYPE_UPLOAD_IMAGE",
        ATTR_SETTER_TYPE_MAP:"ATTR_SETTER_TYPE_MAP",
        ATTR_SETTER_TYPE_PASSWORD:"ATTR_SETTER_TYPE_PASSWORD",
        ATTR_SETTER_TYPE_SMS_VERIFY:"ATTR_SETTER_TYPE_SMS_VERIFY",
        ATTR_SETTER_TYPE_IMAGE_VERIFY:"ATTR_SETTER_TYPE_IMAGE_VERIFY"
    },
    authType:{
        USER_TICKET: "USER_TICKET",
        QRCODE: "QRCODE",
        WECOM_QR: "WECOM_QR",
        SMS: "SMS",
        PWD: "PWD",
        AD: "AD",
        LDAP: "LDAP",
        PAMAGENT: "PAMAGENT",
    },
    getAddon:function(qualifyName, addons) {
        if(addons) {
         for(var i=0;i<addons.length;i++){
             if(addons[i].inheritTypes&&addons[i].inheritTypes.indexOf(qualifyName)>-1){
                 return addons[i];
             }
         }
        } else {
          return undefined;
        }
    },
    getValue:function(attr,data,setter){
        if(data && data[attr.code]){
            if(setter){
                switch(setter.type){
                    case this.metaType.ATTR_SETTER_TYPE_LINK_TO:
                        return data[attr.code][setter.linkToDataTypeDisplayName]
                }
                return data[attr.code];
            }else{
                return data[attr.code];
            }
        }
    },
    getVerifyUtils:function(attrs){
        var utils = {};
        for(var i=0;i<attrs.length;i++){
            var valid = this.getAddon(this.metaType.QNAME_ATTRIBUTE_ADDON_VALIDATOR,attrs[i].addons);
            if(valid && valid.validator){
                var validator = JSON.parse(valid.validator);
                var config = validator.embeddedConfig?JSON.parse(validator.embeddedConfig):{};
                utils[attrs[i].code] = config;
            }
        }
        return utils;
    },
    verifyUtils:function(attrs){
        var verify = {};
        var verifyU = this.getVerifyUtils(attrs);
        for(var code in verifyU){
            verify[code] = function(value,item){
                var config = verifyU[$(item).attr("name")];
                if(!value)return false;
                if(config.regexp){
                    //console.log(config)
                    var reg = new RegExp(config.regexp);
                    if (!reg.test(value)) {
                        return config.regexpErrorMsg?config.regexpErrorMsg:"格式不正确";
                    }
                }
                if(config.minLength){
                    if (value.length<config.minLength) {
                        return "不能少于"+config.minLength+"个字符";
                    }
                }
                if(config.maxLength){
                    if (value.length>config.maxLength) {
                        return "不能超过"+config.maxLength+"个字符";
                    }
                }
            }
        }
        return verify;
    },
    getFieldTypeByDataType:function(dataType){
        switch (dataType) {
            case 'Double':
              return "number";
            case 'Long':
              return "number";
            case 'Boolean':
              return "boolean";
            case 'Date':
              return "date";
            default:
              return "input"
        }
    },
    getRules:function(attr){
        var rules = [attr.code];
        if(attr.required){
            rules.push("required");
        }
        return rules;
    },
    buildField:function(attr,formDefine){
        var hideAttrs = formDefine.hideAttrs?formDefine.hideAttrs:[];
        var disabledAttrs = formDefine.disabledAttrs?formDefine.disabledAttrs:[];
        var field = {
            display: attr.displayName,
            fieldName:attr.code,
            description:attr.description,
            hide:hideAttrs.indexOf(attr.code)>-1,
            disabled:disabledAttrs.indexOf(attr.code)>-1,
            rules:this.getRules(attr)
        };
        var setter = this.getAddon(this.metaType.QNAME_ATTRIBUTE_ADDON_SETTER,attr.addons);
        if(setter){
            switch (setter.type) {
                case this.metaType.ATTR_SETTER_TYPE_GLOBAL_DICTIONARY:
                case this.metaType.ATTR_SETTER_TYPE_INTERNAL_DICTIONARY:
                    var options = metaService.queryDataByFinder({
                        code: "defaultFinder",
                        size:10000,
                        dataTypeQualifyName: this.metaType.QNAME_DICTIONARY_DATA,
                        userInput:{dictId:setter.dictionaryId}
                    })
                    field.type = "select";
                    field.options = options.result;
                    field.code = "value";
                    field.name = "displayName";
                    break;
                case this.metaType.ATTR_SETTER_TYPE_PASSWORD:
                    field.type = "password";
                    break;
                case this.metaType.ATTR_SETTER_TYPE_LINK_TO:
                    field.type = "linkTo";
                    field.dataTypeId = setter.linkToDataType;
                    field.code = setter.linkToAttribute;
                    field.name = setter.linkToDataTypeDisplayName;
                    break;
                case this.metaType.ATTR_SETTER_TYPE_UPLOAD_IMAGE:
                    field.type = "uploadImage";
                    break;
                case this.metaType.ATTR_SETTER_TYPE_UPLOAD_FILES:
                    field.type = "uploadFile";
                    break;
                case this.metaType.ATTR_SETTER_TYPE_SMS_VERIFY:
                    field.type = "sms";
                    field.smsVerifyConfig = setter.smsVerifyConfig;
                    break;
                case this.metaType.ATTR_SETTER_TYPE_IMAGE_VERIFY:
                    field.type = "imgVerify";
                    break;
                    
                    
                    
            }
        }else{
            field.type = this.getFieldTypeByDataType(attr.type);
        }

        return field;
    },
    buildMetaTypeFields:function(param){
        var data = metaService.listInheritAttributes({qualifyName:param.qualifyName});
        var fields = [];
        var formDefine = param.formDefine?param.formDefine:{};
        for(var i=0;i<data.length;i++){
            fields.push(this.buildField(data[i],formDefine));
        }
        return {
            fields:fields,
            attrs:data
        };
    },
    buildFormData:function(param){
        var result = this.buildMetaTypeFields(param);
        console.log(param)
        return {
            attrs:result.attrs,
            form:{
                data:param.data,
                fields: result.fields,
                submitText:param.submitText,
                callback:param.callback?param.callback:null
            }
        }
    },
    coverFormData:function(data,attrs){
        for(var i=0;i<attrs.length;i++){
            var setter = this.getAddon(this.metaType.QNAME_ATTRIBUTE_ADDON_SETTER,attrs[i].addons);
            if(setter){
                switch(setter.type){
                    case this.metaType.ATTR_SETTER_TYPE_UPLOAD_IMAGE:
                    case this.metaType.ATTR_SETTER_TYPE_UPLOAD_FILES:
                    case this.metaType.ATTR_SETTER_TYPE_LINK_TO:
                        data[attrs[i].code] = $("#"+attrs[i].code).attr("data-val");
                        break;
                    
                }
            }else{
                switch(attrs[i].type){
                    case "Boolean":
                        data[attrs[i].code] = data[attrs[i].code] == "true"?true:false;
                        break;
                    case "Date":
                        data[attrs[i].code] = data[attrs[i].code]?new Date(data[attrs[i].code]).getTime():undefined;
                        break;
                    case "Double":
                        data[attrs[i].code] = data[attrs[i].code]?parseFloat(data[attrs[i].code]):undefined;
                        break;
                    case "Long":
                        data[attrs[i].code] = data[attrs[i].code]?parseInt(data[attrs[i].code]):undefined;
                        break;
                }
            }
            
        }
        return data;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/utiles/metaTypeUtils.js
// module id = 5
// module chunks = 0